import React from 'react';
import { SectionCTA } from './SectionCTA';
export function Collection() {
  return <section className="bg-paper px-5 py-16 md:py-24" aria-labelledby="collection-title" data-id="element-98" data-mp="318j7kuul8dam">
      <div className="mx-auto max-w-4xl text-center" data-id="element-99" data-mp="2w96dbp1e03y0">
        <p className="text-sm font-bold uppercase tracking-[0.14em] text-brandDark" data-id="element-100" data-mp="2w9oduxv314bq">The Complete TRT Blueprint Collection</p>
        <h2 id="collection-title" className="mt-3 font-display text-3xl font-black leading-tight text-ink md:text-5xl" data-id="element-101" data-mp="2r88tl80qb1ue">
          Everything You Need to Organize Your TRT Clinical Workflow in One Place
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-slate-600" data-id="element-102" data-mp="3eznzfarps1ae">
          Instead of searching through scattered notes, guidelines, and reference materials, you’ll have a structured
          collection designed to help you navigate the major stages of testosterone therapy.
        </p>

        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-[1fr_auto_1fr] items-center gap-3 rounded-3xl bg-navy p-6 text-white md:p-10" data-id="element-103" data-mp="1ylo6ijradbwn">
          <div data-id="element-104" data-mp="uhi0dmyzhqiq">
            <p className="font-display text-6xl font-black text-brand md:text-8xl" data-id="element-105" data-mp="uevstnc3fb0i">6</p>
            <p className="mt-1 text-sm font-bold uppercase tracking-wide md:text-base" data-id="element-106" data-mp="zfjkmb85bvvs">Premium Volumes</p>
          </div>
          <p className="font-display text-4xl font-black text-slate-500 md:text-6xl" data-id="element-107" data-mp="kl572q7cpeoi">+</p>
          <div data-id="element-108" data-mp="pjynaqe0vjsd">
            <p className="font-display text-6xl font-black text-gold md:text-8xl" data-id="element-109" data-mp="bqh2z3dii31a">5</p>
            <p className="mt-1 text-sm font-bold uppercase tracking-wide md:text-base" data-id="element-110" data-mp="boe5xzdxz9n2">Exclusive Bonuses</p>
          </div>
        </div>

        <SectionCTA label="Get Instant Access for $27" note="Instant download · No recurring payments · 7-day money-back guarantee" data-id="element-111" data-mp="1st544km0few" />
      </div>
    </section>;
}